import { BEST_SELLERS_PRODUCT_LIST } from '../../../../ahm-constants/ui';
import { BestSellerProductType, BestSellerScaleType } from '../../../../types/product';

const getBestSeller = ({ productType, scale }: { productType: BestSellerProductType; scale: BestSellerScaleType }) =>
  BEST_SELLERS_PRODUCT_LIST[productType][scale] ?? null; // Null as there may not be a best seller for the given product type

export default getBestSeller;
